import { Helmet } from 'react-helmet-async';
import { PhysicalOrderListView } from 'src/sections/orderPhysical/view';

export default function PhysicalOrderListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Physical Order List</title>
      </Helmet>

      <PhysicalOrderListView />
    </>
  );
}
